import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="elimination"
// Handles clicking on elimination circles to cross out answer choices
export default class extends Controller {
  static values = {
    letter: String,
    qnumber: Number
  }

  click(event) {
    event.preventDefault()

    const $ = window.$
    if (!$) {
      console.warn('[elimination] jQuery not available')
      return
    }

    const letter = this.letterValue || this.element.getAttribute('data-letter')
    const questionNumber = this.qnumberValue || this.element.getAttribute('data-qnumber')
    const clicked = $(this.element).attr("data-clicked")

    if (!letter || !questionNumber) {
      console.warn('[elimination] Missing letter or question number', { letter, questionNumber })
      return
    }

    if (clicked == "0") {
      // Cross out this elimination circle
      $(this.element).find(".interface-line-yash").css("display", "none")

      // Show line in corresponding question circle
      const question = $("#interface-questions-container-holder-" + questionNumber + "-yash")
        .find(".interface-questions-circle-yash")
        .filter(function() {
          return $(this).attr("data-letter") == letter
        })
      question.find(".interface-line-yash").css("display", "block")

      // Mark as clicked
      $(this.element).attr("data-clicked", "1")

      // Reset the answer if it was selected
      const answerSelection = question
      this.unclickAnswer(answerSelection)
    } else {
      // Uncross this elimination circle
      $(this.element).find(".interface-line-yash").css("display", "block")
      $(this.element).attr("data-clicked", "0")

      // Hide line in corresponding question circle
      const question = $("#interface-questions-container-holder-" + questionNumber + "-yash")
        .find(".interface-questions-circle-yash")
        .filter(function() {
          return $(this).attr("data-letter") == letter
        })
      question.find(".interface-line-yash").css("display", "none")
    }
  }

  unclickAnswer(questionElement) {
    // Helper to unclick an answer (used when elimination is clicked)
    const $ = window.$
    const questionNumber = $(questionElement).attr("data-qnumber")
    const bubbleIndex = parseInt(questionNumber) - 1

    if ($(questionElement).hasClass("interface-filled-green-yash")) {
      $(questionElement).removeClass("interface-filled-green-yash")
      $(questionElement).siblings().removeClass("interface-filled-green-yash")
      $(".interface-bottom-bubble-yash:eq(" + bubbleIndex + ")").removeClass("interface-black-yash")

      const formAnswer = $("#question" + questionNumber + "-yash")
      formAnswer.val("")
    }
  }
}

